import React from 'react';
import { withRouter } from 'inferno-router';
import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  TouchableHighlight,
  View,
} from '../base_components';
import UserStore from '../../stores/user_store';

require('../../css/menu_overlay.less');

const styles = StyleSheet.create({
  menuOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  outside: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
  side: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '20em',
    paddingTop: '2em',
    paddingBottom: '2em',
    backgroundColor: '#93c3c4',
    borderRightWidth: '0.2em',
    borderRightColor: '#01927c',

    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  spacer: {
    flex: 1,
  },
  menuItem: {
    alignSelf: 'stretch',
    height: '4em',
    paddingLeft: '2em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  menuText: {
    color: 'white',
    fontSize: '1.2em',
  },
});

type State = {
  is_open: boolean;
  is_logged_in: boolean;
};
type Props = {
  history: any;
};

let g_overlay = null;
class MenuOverlay extends React.PureComponent<Props, State> {
  state = {
    is_logged_in: false,
    is_open: false,
  };
  componentDidMount() {
    g_overlay = this;
    UserStore.addChangeListener(this._onUserUpdate);
    this._onUserUpdate();
  }
  componentWillUnmount() {
    UserStore.removeChangeListner(this._onUserUpdate);
  }
  _onUserUpdate = () => {
    const is_logged_in = UserStore.isLoggedIn();
    this.setState({ is_logged_in });
  };
  static open() {
    g_overlay && g_overlay.setState({ is_open: true });
  }
  _onItemPress = to => {
    this.setState({ is_open: false });
    this.props.history.push(to);
  };

  _onClosePress = () => this.setState({ is_open: false });

  render() {
    const { is_logged_in, is_open } = this.state;

    let extra_class = 'menu-overlay';
    if (is_open) {
      extra_class += ' menu-overlay-open';
    }

    let bottom = null;
    if (is_logged_in) {
      bottom = (
        <MenuItem text='Account' to='/account' onPress={this._onItemPress} />
      );
    } else {
      bottom = (
        <MenuItem text='Login' to='/login' onPress={this._onItemPress} />
      );
    }

    return (
      <View style={styles.menuOverlay} className={extra_class}>
        <TouchableWithoutFeedback
          style={styles.outside}
          className='menu-overlay-outside'
          onPress={this._onClosePress}
        />
        <View style={styles.side} className='menu-overlay-side'>
          <MenuItem text='Home' to='/' onPress={this._onItemPress} />
          <MenuItem text='Prizes' to='/prizes' onPress={this._onItemPress} />
          <MenuItem text='Games' to='/games' onPress={this._onItemPress} />
          <MenuItem text='Crypto' to='/crypto' onPress={this._onItemPress} />
          <View style={styles.spacer} />
          {bottom}
        </View>
      </View>
    );
  }
}
export default withRouter(MenuOverlay);

function MenuItem(props) {
  const { text, to, onPress } = props;
  function _onPress() {
    onPress(to);
  }
  return (
    <TouchableHighlight
      style={styles.menuItem}
      underlayColor='rgba(0,0,0,0.3)'
      onPress={_onPress}
    >
      <Text style={styles.menuText}>{text}</Text>
    </TouchableHighlight>
  );
}
